import { Link, useLocation } from "react-router-dom";
import Cover from "../../components/Cover/Cover";
import "./CatalogPage.css";
import { useState } from "react";

const texts = {
  ua: {
    services: "Наша продукція",
    allProducts: "Всі товари",
  },
  ru: {
    services: "Наша продукция",
    allProducts: "Все товары",
  },
};

const CatalogPage = ({
  path,
  metaTitle,
  metaDescription,
  coverTitle,
  coverImage,
  coverImageMobile,
  aboutTitle,
  aboutTexts,
  aboutImage,
  brands,
}) => {
  const isMobile = window.innerWidth <= 1199;
  const coverImageToUse = isMobile ? coverImageMobile : coverImage;
  const location = useLocation();
  const currentLang = location.pathname.startsWith("/ru") ? "ru" : "ua";
  const langPrefix = currentLang === "ru" ? "/ru" : "";
  const t = texts[currentLang];
  const hasManyBrands = brands.length > 1;
  const tabs = hasManyBrands
    ? [...brands.map((b) => b.name), t.allProducts]
    : [];
  const [activeTab, setActiveTab] = useState(
    hasManyBrands ? tabs[0] : brands[0].name
  );

  let products = [];
  if (!hasManyBrands) {
    products = brands[0].products;
  } else if (activeTab === "all") {
    products = brands.flatMap((b) => b.products);
  } else {
    const brand = brands.find((b) => b.name === activeTab);
    products = brand ? brand.products : [];
  }

  return (
    <div className="catalog__page">
      <title>{metaTitle}</title>
      <meta name="description" content={metaDescription} />
      <Cover text={coverTitle} src={coverImageToUse} />
      <section className="catalog__page-about">
        <div className="catalog__page-about-texts">
          <h2 className="catalog__page-about-title mont-m">{aboutTitle}</h2>
          {aboutTexts.map((text, idx) => {
            return (
              <p key={idx} className="catalog__page-about-text int-r-21">
                {text}
              </p>
            );
          })}
        </div>
        <img
          src={aboutImage}
          alt={`${coverTitle} Пасторал Мумуля`}
          className="catalog__page-about-image"
        />
      </section>
      <section className="catalog__page-tabs-section">
        <h2 className="catalog__page-tabs-section-title mont-m">
          {t.services}
        </h2>
        {hasManyBrands && (
          <div className="catalog__page-tabs">
            {tabs.map((tab, idx) => {
              const brand = brands.find((b) => b.name === tab);
              const isActive =
                activeTab === tab ||
                (tab === t.allProducts && activeTab === "all");

              const logoClass =
                tab === "Pastoral"
                  ? "logo-pastoral"
                  : tab === "МУМУЛЯ"
                  ? "logo-mumulya"
                  : "";

              return (
                <button
                  key={idx}
                  className={`catalog__page-tab ${
                    isActive ? "active" : ""
                  } mont-m`}
                  onClick={() =>
                    setActiveTab(tab === t.allProducts ? "all" : tab)
                  }
                >
                  {brand && (
                    <img
                      src={brand.logo}
                      alt={brand.name}
                      className={`catalog__page-tab-logo ${logoClass}`}
                    />
                  )}
                  <span>{tab}</span>
                </button>
              );
            })}
          </div>
        )}
        <div className="catalog__page-products">
          {products.map((p, idx) => (
            <Link
              to={`${path}${p.link}`}
              key={idx}
              className="catalog__page-product"
            >
              <div className="catalog__page-product-image-wrapper">
                <img
                  className="catalog__page-product-image"
                  src={p.image}
                  alt={`${p.title}`}
                />
              </div>
              <p>{p.title}</p>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
};

export default CatalogPage;
